import React, { lazy, Suspense } from "react";
import CWOConfigProvider from "helpers/cwoConfigProvider";
import Loading from "helpers/loading/loading";

const Component = lazy(() => import("components/manual-task-new-design/pages/index"));

const ManualTaskIndexNewDesign = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default ManualTaskIndexNewDesign;
